import React, {useContext, useMemo, useEffect} from 'react';
import {Icon, ListItem, ListItemText} from '@material-ui/core';
import {withRouter} from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {Badge, NavLink} from '../../../index';
import Box from '@material-ui/core/Box';
import IntlMessages from '../../../utility/IntlMessages';
import useStyles from './VerticalItem.style';
import AppContext from '../../../utility/AppContext';
import {checkPermission} from '../../../utility/Utils';
import {useSelector} from 'react-redux';
import {CustomersContext} from '../../../../provider/CustomerContextProvider';

const VerticalItem = ({level, item}) => {
  const {themeMode} = useContext(AppContext);
  const classes = useStyles({level, themeMode});
  const {user} = useSelector(({auth}) => auth);
  const [customerProviderState, dispatch] = useContext(CustomersContext);
  const hasPermission = useMemo(() => checkPermission(item.auth, user.role), [
    item.auth,
    user.role,
  ]);

  /*** updating badge count when user leave the  support ticket menu */
  useEffect(() => {
    if (item.id === 'support-ticket') {
      changeBadgeCount(customerProviderState.latestSupportTicketCount);
    } else if (item.id === 'alerts') {
      changeBadgeCount(customerProviderState.alertBadgeCount);
    }
  }, [customerProviderState.latestSupportTicketCount, customerProviderState.alertBadgeCount]);

  /** changing badge count */
  useEffect(() => {
    if (item.id === 'support-ticket') {
      changeBadgeCount(user.ticketCounts);
    }
  }, [user.ticketCounts]);

  useEffect(() => {
    if (item.id === 'alerts') {
      changeBadgeCount(user.alertsCount);
    }
    //console.log(user, " user ");
  }, [user.alertsCount]);

  const changeBadgeCount = (badgeCount) => {
    // console.log(badgeCount, " badgeCount ", item.id)
    if (item.id === 'support-ticket') {
      item.count = badgeCount;
    }
    if (item.id === 'alerts') {
      item.count = badgeCount;
    }
  };
  

  if (!hasPermission) {
    return null;
  }

  /** making badge count 0 when click on support ticket menu*/
  const handleRemoveBadge = (e) => {
    if (item.id === 'support-ticket') {
      item.count = 0;
    } else if( item.id === 'alerts' ){
      item.count = 0;
    }
  };

  return (
    <ListItem
      button
      component={NavLink}
      to={item.url}
      activeClassName='active'
      className={clsx(classes.navItem, 'nav-item')}
      onClick={(e) => {
        
                      if(item.id === 'support-ticket'){
                        handleRemoveBadge();
                      } else if(item.id === 'alerts'){
                        handleRemoveBadge();
                      } else {
                        
                      }
                    }      
      }
      exact={item.exact}>
      {item.icon && (
        <Box component='span' mr={6}>
          <Icon
            className={clsx(classes.listIcon, 'nav-item-icon')}
            color='action'>
            {item.icon}
          </Icon>
        </Box>
      )}
      <ListItemText
        primary={<IntlMessages id={item.messageId} />}
        classes={{primary: 'nav-item-text'}}
      />
      {(item.count && item.count > 0) ? (
        <Box mr={1} clone>
          <Badge count={item.count} color={item.color} />
        </Box>
      ) : null}
    </ListItem>
  );
};

VerticalItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
  }),
};

VerticalItem.defaultProps = {};

export default withRouter(React.memo(VerticalItem));
